import React from 'react';
import './FieldPlayersCount.css';
import {PlayerIcon} from '../../coloredIcons/PlayerIcon/PlayerIcon';

/**
 * Сколько игроков помещается на поле: число и силуэт игрока у правого края
 * кнопки выбора поля. Само название поля собственное («Три холма»), и
 * вместимость по нему не угадать — ее показывает этот счетчик.
 *
 * Силуэт — тот же PlayerIcon, что и в списке лобби: маска красится цветом
 * текста кнопки, поэтому иконка не выпадает из кнопки ни в обычном, ни в
 * наведенном состоянии.
 *
 * @param {number} [playersCount] — у полей без вместимости (случайное,
 *   пустое, тестовое) счетчика нет
 */
function FieldPlayersCount({playersCount}) {
  if (!playersCount) {
    return null;
  }

  return (
    <span className="field-players-count" title={`Игроков на поле: ${playersCount}`}>
      <span>{playersCount}</span>
      <PlayerIcon className="field-players-count-icon" color="currentColor" isSmall/>
    </span>
  );
}

export default FieldPlayersCount;
